module.exports = __webpack_public_path__ + "assets/images/project/malaysia.jpg?v=6af10729";